module.exports = __webpack_public_path__ + "img/1573451308.8b05dcf7.jpg";